import classNames from "classnames";

import type {ISearchComboboxLiveRegionProps} from "../types/ISearchComboboxLiveRegionProps";

import * as styles from "./SearchComboboxLiveRegion.module.css";

/**
 * Polite status region for "Szukamy…", result counts, "no results" and errors. Keep it mounted all the time (outside
 * the panel): a region inserted together with its text is often not announced.
 */
export const SearchComboboxLiveRegion = (props: ISearchComboboxLiveRegionProps) => (
    <div role="status" aria-live="polite" aria-atomic="true" className={classNames(styles.liveRegion, props.className)}>
        {props.message}
    </div>
);
import classNames from "classnames";

import type {ISearchComboboxLiveRegionProps} from "../types/ISearchComboboxLiveRegionProps";

import * as styles from "./SearchComboboxLiveRegion.module.css";

/**
 * Polite status region for "Szukamy…", result counts, "no results" and errors. Keep it mounted all the time (outside
 * the panel): a region inserted together with its text is often not announced.
 */
export const SearchComboboxLiveRegion = (props: ISearchComboboxLiveRegionProps) => (
    <div role="status" aria-live="polite" aria-atomic="true" className={classNames(styles.liveRegion, props.className)}>
        {props.message}
    </div>
);
